import { EnvironmentEnum } from './index';

export default {
  ENVIRONMENT: EnvironmentEnum.PRODUCTION,
  API_URL: 'https://haul-safe-document-api-production.haulwith.us',
  WS_URL: 'wss://haul-safe-document-api-production.haulwith.us',
  TICKET_ID_PREFIX: 'HAUL-',
  FMCSA: {
    LINK_FOR_CHECK:
      'https://nationalregistry.fmcsa.dot.gov/search-medical-examiners?as=true&range=10',
  },
  HAULSAFE_PHONE_NUMBER: '(479) 342-4808',
  SEGMENT_ID: 'HCtDZSVpPcEyaXsbJbAwCMYLWuAZwCMa',
  LOGS_LEVEL: process.env.REACT_APP_LOG_LEVEL || 'error',
  LOGS_PROVIDERS: ['sentry'],
  SENTRY_DSN:
    process.env.REACT_APP_SENTRY_DSN ||
    'https://f19a531f7aec4bdf84dc5aef6707dc18@o362769.ingest.sentry.io/4505239493148672',
};
